export default __webpack_public_path__ + "static/media/logo.864a59ba.svg";